export default "__VITE_ASSET__mDSzWsrX__"